import Axios from "axios";
import {
    SET_SALARY_SUMMARY_REPORT_LIST, 
    UNSET_SALARY_SUMMARY_REPORT_LIST
} from "@/store/mutation-types";
import {
    getSalarySummaryReport,
} from "@/store/api";

const state = {
    getSalarySummaryReport: [],
};

const getters = {
    getSalarySummaryReport(state) {
        return state.getSalarySummaryReport;
    },
};

const mutations = {
    [SET_SALARY_SUMMARY_REPORT_LIST](state, data) {
        state.getSalarySummaryReport = data;
    },
    [UNSET_SALARY_SUMMARY_REPORT_LIST](state) {
        state.getSalarySummaryReport = [];
    },
};

const actions = {

    getSalarySummaryReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getSalarySummaryReport}`, { params: data })
                .then((response) => {
                    commit(SET_SALARY_SUMMARY_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_SALARY_SUMMARY_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};